exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col[data-v-1b61714e]{padding:0!important}.rg-contact-details-heightz[data-v-1b61714e]{padding-left:32px;padding-right:10px;overflow-y:auto}", ""]);

// exports
